import * as Function from "../Function";
import * as Error from "../Error";
import * as ErrorCode from "../ErrorCode";
import { Option, some, none } from "fp-ts/lib/Option";

export const nullable: Function.TValidationFunction = (value: unknown): Option<Error.TValidationError> =>
    typeof value === "undefined" || value === null
        ? none
        : some([[ErrorCode.validationErrorCodeConstants.NULL_VALIDATION]]);
